// extracted by mini-css-extract-plugin
export default {"icon":"CartIcon_icon__ZjoI1"};